export interface IDocumentValidation {
    maxSizeMB: number;
    allowedTypes: string[];
}

export const DOCUMENT_VALIDATION: Record<string, IDocumentValidation> = {
    BANK_STATEMENT: {maxSizeMB: 5, allowedTypes: ["pdf", "jpg", "png"]},
    RATION_CARD: {maxSizeMB: 2, allowedTypes: ["pdf", "jpg", "png"]},
    CERTIFICATE: {maxSizeMB: 5, allowedTypes: ["pdf", "jpg", "png", "jpeg"]},
    HSC: {maxSizeMB: 10, allowedTypes: ["pdf", "jpg", "png"]},
    UG: {maxSizeMB: 10, allowedTypes: ["pdf", "jpg", "png"]},
    PG: {maxSizeMB: 10, allowedTypes: ["pdf", "jpg", "png"]},
    SSC: {maxSizeMB: 10, allowedTypes: ["pdf", "jpg", "png"]},

    OFFER_LETTER: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    APPOINTMENT_LETTER: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    APPRAISAL_LETTER: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    PROMOTION_LETTER: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    PREVIOUS_EXPERIENCE_LETTER: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    NDA: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    JOINING_FORM: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    RESIGNATION_LETTER: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    RELIEVING_LETTER: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    NO_DUES_CLEARANCE: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    BANK_ACCOUNT_PROOF: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    INCOME_TAX_RETURN: {maxSizeMB: 10, allowedTypes: ["pdf"]},
    SALARY_SLIP: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    FORM_16: {maxSizeMB: 5, allowedTypes: ["pdf"]},
    POLICY: {maxSizeMB: 5, allowedTypes: ["pdf"]},

    AADHAAR_CARD: {maxSizeMB: 5, allowedTypes: ["pdf", "jpg", "png"]},
    PAN_CARD: {maxSizeMB: 5, allowedTypes: ["pdf", "jpg", "png"]},
    PASSPORT: {maxSizeMB: 10, allowedTypes: ["pdf", "jpg", "png"]},
    VOTER_ID: {maxSizeMB: 5, allowedTypes: ["pdf", "jpg", "png"]},
    DRIVING_LICENSE: {maxSizeMB: 5, allowedTypes: ["pdf", "jpg", "png"]},
    OTHERS: {maxSizeMB: 10, allowedTypes: ["pdf", "jpg", "png"]},

    PROFILE_PHOTO: {maxSizeMB: 2, allowedTypes: ["jpeg", "png", "jpg"]},
    PASSPORT_PHOTO: {maxSizeMB: 2, allowedTypes: ["jpeg", "png", "jpg"]},
    SIGNATURE_PHOTO: {maxSizeMB: 2, allowedTypes: ["jpeg", "png", "jpg"]},
    BIRTHDAY_PHOTO: {maxSizeMB: 3, allowedTypes: ["jpeg", "png", "jpg"]},
    WORK_ANNIVERSARY_PHOTO: {maxSizeMB: 3, allowedTypes: ["jpeg", "png", "jpg"]},
    EVENT_PHOTO: {maxSizeMB: 3, allowedTypes: ["jpeg", "png", "jpg"]},
    ACHIEVEMENT_PHOTO: {maxSizeMB: 3, allowedTypes: ["jpeg", "png", "jpg"]},
};